





















import {Component, Vue, Prop} from "vue-property-decorator";
import Attribute from "@/api/Product/Attribute";
import Product from "@/api/Product";
import RenderProductAttributeTextarea from "@/components/Product/Attributes/RenderProductAttributeTextarea.vue";
import RenderProductAttributeText from "@/components/Product/Attributes/RenderProductAttributeText.vue";
import RenderProductAttributeSelect from "@/components/Product/Attributes/RenderProductAttributeSelect.vue";
import RenderProductAttributeBoolean from "@/components/Product/Attributes/RenderProductAttributeBoolean.vue";
import RenderProductAttributeMultiSelect from "@/components/Product/Attributes/RenderProductAttributeMultiSelect.vue";

@Component({
  components: {
    RenderProductAttributeMultiSelect,
    RenderProductAttributeBoolean,
    RenderProductAttributeSelect,
    RenderProductAttributeText,
    RenderProductAttributeTextarea
  }
})
export default class RenderProductAttribute extends Vue {
  @Prop() private product!: Product;
  @Prop() private attribute!: Attribute;

  private consideredYes = ['بلی', 'بله', 'دارد']
  private consideredNo = ['خیر', 'ندارد']

  equalsYes(): boolean{
    if(this.attribute.attribValue && this.consideredYes.includes(this.attribute.attribValue)){
      return true;
    }
    return false;
  }

  equalsNo(): boolean{
    if(this.attribute.attribValue && this.consideredNo.includes(this.attribute.attribValue)){
      return true;
    }
    return false;
  }

  isEmpty(): boolean{
    if(this.attribute.baseValue){
      return false;
    }
    return true;
  }
}
